module.exports = __webpack_public_path__ + "img/background.fcc85e0f.png";